// PDP main product
window.productJS = function (productVariants) {
    $(function () {
        var changeImage = false

        function updateOptionSelector() {
            var serialize = $('#select-options').serializeArray()
            const result = Object.entries(serialize).map(([key, val]) => val.value).join(" / ");

            $(`.variant option`).each(function (key, value) {
                if ($(value).html() === result) {
                    $(`.variant`).val($(value).val())
                }
            })
            var selectedVariantObject = productVariants.find(function (x) {
                return  x.id === parseInt($(`.variant`).val())
            });

            history.pushState(null, "", '?variant='+selectedVariantObject.id);
            var variantPrice = selectedVariantObject.price;
            var variantPrice_formatted = Shopify.api.formatMoney(selectedVariantObject.price);
            var compareAtPrice = false;	
            if(selectedVariantObject.compare_at_price > selectedVariantObject.price) {	
                compareAtPrice = true;	
            }

            let variantSkus = new Array();
            //let variantSkus = [];
            let selectedQuantity = 1;
            let selectedSku = selectedVariantObject.sku;
            for (let i = 0; i < productVariants.length; i++) {
                variantSkus.push(productVariants[i].sku);
            }
            window.bwp.updateWidget(selectedSku, selectedQuantity, variantSkus);
            if (selectedVariantObject.selling_plan_allocations[0]) {
                var variantSubscriptionPrice = selectedVariantObject.selling_plan_allocations[0].price;
                var variantSubscriptionPrice_formatted = Shopify.api.formatMoney(selectedVariantObject.selling_plan_allocations[0].price);

                if ($('input.rc_widget__option__input:checked').val() === 'subsave') {
                    if (variantPrice >  variantSubscriptionPrice) {	
                        $('#product-price-value').html(`<span>${variantPrice_formatted}</span>&nbsp; ${variantSubscriptionPrice_formatted}`)	
                    } else {	
                        $('#product-price-value').html(variantSubscriptionPrice_formatted)	
                    }
                } else {
                    if (compareAtPrice) {	
                        $('#product-price-value').html(`<span>${Shopify.api.formatMoney(selectedVariantObject.compare_at_price)}</span>&nbsp; ${variantPrice_formatted}`);    	
                    } else {	
                        $('#product-price-value').html(variantPrice_formatted);	
                    }
                }

                const oneTimeOption = $('.rc_widget__option--onetime')
                const subscriptionOption = $('.rc_widget__option--subsave')

                if (oneTimeOption) {
                    oneTimeOption.find('.rc_widget__price').html(variantPrice_formatted)
                }
                if (subscriptionOption) {
                    subscriptionOption.find('.rc_widget__price').html(variantSubscriptionPrice_formatted)
                }
            } else {
                if (compareAtPrice) {	
                    $('#product-price-value').html(`<span>${Shopify.api.formatMoney(selectedVariantObject.compare_at_price)}</span>&nbsp; ${variantPrice_formatted}`)	
                } else {	
                    $('#product-price-value').html(variantPrice_formatted)	
                }
            }

            if (changeImage) {
                var $variantImage = $(`#variant-image-${selectedVariantObject.id}`)
                if ($variantImage.length > 0) {
                    window.productSwiper.slideTo( $variantImage.index() );
                }
            }
            $('#out-of-stock-container').show();
            
            if (selectedVariantObject.available === false) {
                $('#out-of-stock-container').show();
                $('#find-near-you').show();
                //$('.pdp__summary-inner .AddToCartForm').hide();
                $('.rc-widget-injection-parent').hide();  // product.template
                $('#save-content').hide();  // True energy supplement
                $('.pdp__addcart').hide();  
                $('.rc-container-wrapper').hide();
            }
            if (selectedVariantObject.available === true) {
                $('#out-of-stock-container').hide();
                $('#find-near-you').hide();
                //$('.pdp__summary-inner .AddToCartForm').show();
                $('.rc-widget-injection-parent').show();  // product.template
                $('#save-content').show();  // True energy supplement template
                $('.pdp__addcart').show();
                $('.rc-container-wrapper').show();
            }

            /*
            if (selectedVariantObject.available === false) {
                $('#out-of-stock-container').show();
                $('#find-near-you').show();
                $('.pdp__summary-inner .AddToCartForm').hide();
            }
            if (selectedVariantObject.available === true) {
                $('#out-of-stock-container').hide();
                $('.pdp__summary-inner .AddToCartForm').show();
            }*/
        }

        updateOptionSelector();

        $(document).on('click', '.option-radio', function () {
            var $ul = $(this).parents('.pdp-size__list');
            $ul.find('.pdp-size__item').removeClass('pdp-size__item--active');

            $(this).parents('.pdp-size__item').addClass('pdp-size__item--active');

            changeImage = true;
            updateOptionSelector();
        })

        $(document).on('click', '.rc_widget__option', function (e) {

            if (e.hasOwnProperty('originalEvent')) {
                $(this).find('.rc_widget__option__input').click()
            }

            updateOptionSelector();
        })
		
		
	$(".custom-sorting .selected, .custom-sorting .yotpo-icon-down-triangle").on("click", function() {
            $(".custom-sorting .yotpo-dropdown.list-categories").toggle();
        });
        $("body").on("click", function(event) {
            if (!$(event.target).closest('.custom-sorting .selected, .custom-sorting .yotpo-icon-down-triangle').length) {
                // ... clicked on the 'body', but not inside of #menutop
                $(".custom-sorting .yotpo-dropdown.list-categories").hide();
            }
            
        });
		
    })
}

//product cards
$(function() {
    let productsContainer = document.querySelector("body"), variantId, variantPrice;

    productsContainer.addEventListener("click", (ev) => {
      let sizeLink = ev.target;
      if (sizeLink.classList.contains("variant-title")) {
        let variantAvailable = sizeLink.closest('.pdp-size__item').dataset.available;
        if (variantAvailable == 'true') {
            let links = sizeLink.closest('.pdp-size__list').querySelectorAll(".pdp-size__item span");
            [...links].forEach((x) => x.classList.remove("pdp-size__item--active"));
            sizeLink.classList.add("pdp-size__item--active");
            variantId = sizeLink.closest('.pdp-size__item').dataset.variant;
            variantPrice = sizeLink.closest('.pdp-size__item').dataset.variant_price;
            sizeLink.closest('.card__bottom').querySelector('.AddToCartForm button').innerHTML = 'Add to Bag - ' + variantPrice;
            sizeLink.closest('.card__bottom').querySelector('input[name="id"]').value = variantId;
        }
      }
    });
  });



  

 
